import Alert from 'components/popup/alert/Alert';
import MyPage from 'components/popup/myPage/MyPage';
import { MENU_STATE, TMainMenu, TUserMenu, USER_MENU } from 'constants/Constants';
import { useAuthentication } from 'hooks/feature/authentication/useAuthentication';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { redirectAdmin } from 'utils/AuthenticationUtil';
import { TMenubar } from '../TMenubar';
import MenuItem from '../menuItem/MenuItem';
import { TUserMenuItem } from '../menuItem/MenuItem.type';
import styles from './UserMenuList.module.scss';
const UserMenu = (prop: TMenubar<TUserMenuItem>) => {
    const { t } = useTranslation();
    const { expireToken } = useAuthentication();
    const [isShowMyPage, setShowMyPage] = useState(false);
    const [isShowAlert, setIsShowAlert] = useState(false);

    const onClick = <T extends TMainMenu | TUserMenu>(event: React.MouseEvent, state: T) => {
        switch (state) {
            // TODO: 관리자만 보이게 처리
            case USER_MENU.MANAGER: {
                redirectAdmin();
                break;
            }
            case USER_MENU.INFO: {
                setShowMyPage(true);
                break;
            }
            case USER_MENU.LOGOUT: {
                setIsShowAlert(true);
                break;
            }
        }
    };

    const logout = () => {
        expireToken();
    };

    return (
        <>
            <div className={styles.container}>
                {prop.itemList.length > 0 &&
                    prop.itemList.map(({ type, roles }, idx) => {
                        return <MenuItem type={type} roles={roles} key={`${type}-${idx}`} onClick={onClick} state={MENU_STATE.USER}></MenuItem>;
                    })}
            </div>
            {isShowMyPage && <MyPage onClose={() => setShowMyPage(false)} />}
            {isShowAlert && <Alert onConfirm={logout} onClose={() => setIsShowAlert(false)}>
                <span>{t(`logout`)}</span>
            </Alert>}
        </>
    );
};

export default UserMenu;
